import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateChatBanRequest } from '@nucleus-commerce/api-client/admin';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function useBanMutations(storeId: string) {
  const queryClient = useQueryClient();
  const refresh = () => queryClient.invalidateQueries({ queryKey: chatSettingsKeys.bans(storeId) });

  const create = useMutation({
    mutationFn: (body: CreateChatBanRequest) => chatSettingsApi.createBan(storeId, body),
    meta: { successMessage: 'chatSettings:toasts.banned', silentError: true },
    onSuccess: refresh,
  });
  const remove = useMutation({
    mutationFn: (id: string) => chatSettingsApi.deleteBan(storeId, id),
    meta: { successMessage: 'chatSettings:toasts.unbanned' },
    onSuccess: refresh,
  });
  return { create, remove };
}
